<div class="wrapper">
    <section *ngFor="let mission of missions">
        <app-detail-summary [mission]="mission" [doesShowRoute]="true"></app-detail-summary>
    </section>
</div>
